import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const UserInfoActions = createActionGroup({
  source: 'UserInfo',
  events: {
    'Get User Info': props<{ nextStep: any; onError: any }>(),
    'Get User Info Success': props<{ userInfo: any; nextStep: any }>(),
    'Sign In': props<{ pendingAction: PendingAction }>(),
    'Pending Sign In': emptyProps(),
    'Set Customer First And Last Name': props<{ firstName: string }>(),
    'Load Banned Words': emptyProps(),
    'Validate Customer Name': emptyProps(),
  },
});
